import { NgZorroModule } from './../../ng-zorro.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BellComponent } from './bell/bell.component';



@NgModule({
  declarations: [BellComponent],
  imports: [
    CommonModule,
    NgZorroModule
  ],
  exports: [
    BellComponent
  ]
})
export class NotificationModule { }
